import { render, staticRenderFns } from "./AddMyPosition.vue?vue&type=template&id=df78d5d2"
import script from "./AddMyPosition.vue?vue&type=script&lang=js"
export * from "./AddMyPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports